import React, { ReactChild } from 'react';

interface ChildProps {
  children: ReactChild | ReactChild[];
  center?: boolean;
  marginBottomClass?: string;
}

export default function TitleContainer({ children, center, marginBottomClass }: ChildProps): JSX.Element {
  return <div className={`${marginBottomClass} ${center ? 'text-center' : ''}`}>{children}</div>;
}

TitleContainer.defaultProps = {
  center: false,
  marginBottomClass: 'mb-4',
};
